import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate, useLocation } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";
import { AuthProvider, useAuth } from "@/context/AuthContext";
import Layout from "@/components/Layout";
import Login from "@/pages/Login";
import Dashboard from "@/pages/Dashboard";
import Challenge from "@/pages/Challenge";
import CommandCenter from "@/pages/CommandCenter";
import Whales from "@/pages/Whales";
import Trades from "@/pages/Trades";
import Backtest from "@/pages/Backtest";
import Account from "@/pages/Account";
import SettingsPage from "@/pages/Settings";
import ApiKeys from "@/pages/ApiKeys";
import Audit from "@/pages/Audit";

function Protected({ children }) {
  const { user } = useAuth();
  const loc = useLocation();
  if (user === null) return <div className="min-h-screen bg-[#090A0F] flex items-center justify-center font-mono text-xs text-zinc-500">AUTHENTICATING…</div>;
  if (!user) return <Navigate to="/login" replace state={{ from: loc.pathname }} />;
  return children;
}

function App() {
  return (
    <AuthProvider>
      <BrowserRouter>
        <Routes>
          <Route path="/login" element={<Login />} />
          <Route element={<Protected><Layout /></Protected>}>
            <Route path="/" element={<Dashboard />} />
            <Route path="/challenge" element={<Challenge />} />
            <Route path="/agents" element={<CommandCenter />} />
            <Route path="/whales" element={<Whales />} />
            <Route path="/trades" element={<Trades />} />
            <Route path="/backtest" element={<Backtest />} />
            <Route path="/account" element={<Account />} />
            <Route path="/settings" element={<SettingsPage />} />
            <Route path="/settings/api-keys" element={<ApiKeys />} />
            <Route path="/audit" element={<Audit />} />
          </Route>
        </Routes>
      </BrowserRouter>
      <Toaster theme="dark" position="bottom-right" />
    </AuthProvider>
  );
}

export default App;
